import Box from './Box';
import SearchIcon from './SearchIcon';

export default function SearchBar({ value, onInput }) {
	return (
		<Box name="search-container">
			<SearchIcon />
			<Box component="input" type="text" value={value} onInput={onInput} name="search" placeholder="Search forms" />
		</Box>
	);
}
